import Page, { PageProps } from "./Page";

export { Page, PageProps };

export default Page;
